import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, IconButton, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ArchiveIcon from '@mui/icons-material/Archive';

interface CampaignHeaderProps {
  totalCount: number;
  onCreateClick: () => void;
  showArchivedLink?: boolean;
}

const CampaignHeader: React.FC<CampaignHeaderProps> = ({
  totalCount,
  onCreateClick,
  showArchivedLink
}) => {
  const campaignText = totalCount === 1 ? 'campaign' : 'campaigns';
  const subtitle =
    totalCount > 0
      ? `${totalCount} ${campaignText}`
      : 'Automate prospecting with Dokai';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '32px'
      }}
    >
      <Box>
        <Typography
          variant="h4"
          sx={{
            fontWeight: '700',
            color: (theme) => theme.customColors.themeNeutralPrimaryColor,
            marginBottom: '8px'
          }}
        >
          Campaigns
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: (theme) => theme.palette.text.secondary
          }}
        >
          {subtitle}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {showArchivedLink && (
          <Tooltip title="View archived">
            <IconButton
              component={RouterLink}
              to="/campaign/archived"
              aria-label="View archived"
              sx={(theme) => ({
                color: theme.palette.text.secondary,
                borderRadius: '8px',
                paddingY: '10px',
                '&:hover': {
                  backgroundColor: theme.palette.action.hover
                }
              })}
            >
              <ArchiveIcon fontSize="medium" />
            </IconButton>
          </Tooltip>
        )}
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onCreateClick}
          sx={(theme) => ({
            backgroundColor: theme.customColors.themePrimary,
            color: theme.customColors.themeSecondary,
            textTransform: 'none',
            borderRadius: '8px',
            padding: '10px 24px',
            fontWeight: '600',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: theme.customColors.themePrimary,
              boxShadow: `0 4px 12px ${theme.customColors.themePrimary}40`
            }
          })}
        >
          Create New Campaign
        </Button>
      </Box>
    </Box>
  );
};

export default CampaignHeader;
